import apolloClient from "../apolloClient";
import gql from 'graphql-tag'

class ClinicScheduleService {
  async getClinicSchedule(clinicId, month, year) {
    if (month === null || month  === undefined) {
      month = new Date().getMonth() + 1;
    }
    if (year === null || year === undefined) {
      year = new Date().getFullYear();
    }

    const QUERY = gql`
      query GetAvailableSlotsMonth($clinicId: String!, $month: Int!, $year: Int!) {
        getAvailableSlotsMonth(clinicId: $clinicId, month: $month, year: $year) {
          year
          month
          slots {
            date
            slots {
              startTime
              endTime
              availableSlots
            }
          }
        }
      }
    `
    const response = await apolloClient.query({
      query: QUERY,
      variables: {
        clinicId: clinicId,
        month: month,
        year: year,
      },
    })
    return response.data.getAvailableSlotsMonth;
  }
}

export default new ClinicScheduleService(); 